import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { Component, Injector, OnInit } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { map } from 'rxjs/operators';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-navigation-tabs',
    template: `
        <fi-navigation-tabs
          [tabsModel]="tabs"
          [selectedIndex]="selectedIndex"
          (selectedIndexChange)="onTabIndexChange($event)"
          >
          <ng-container ngProjectAs="header-right-content">
            <div class="ccm-page-header-button-group right-aligned">
              @if (tabs[selectedIndex].AddState && !isMobilePhone()) {
                <button
                  mat-raised-button
                  class="BrandedBackgroundColor fi-header-button"
                  [fiStateSref]="tabs[selectedIndex].AddState"
                  >
                  <span class="fas fa-plus"></span>
                </button>
              }
              @if (currentListData$ | async; as listData) {
                <fi-items-list-more-menu-mobile [listModel]="listData">
                </fi-items-list-more-menu-mobile>
              }
            </div>
          </ng-container>
        </fi-navigation-tabs>
        `,
    styleUrls: ['./fi-form-navigation-tabs.component.scss'],
    standalone: false,
})
export class FiFormNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
        private formService: FiFormService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private detectDeviceService: DetectDevicesService,
        private fiSignalRHelperService: FiSignalRHelperService,
        private pageTitleService: PageTitleService,
    ) {
        super(injector);
    }

    get currentListData$() {
        return this.formService.currentListData$;
    }

    ngOnInit() {
        this.tabs.push({
            Title: this.appTextService.get('form.module_name'),
            Sref: FiStateNames.Form.List,
            SrefParams: { filterType: SideListOptionType.FormsToAnswer },
            AddState: this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.FormLocal,
                AccessRightType.Share,
            )
                ? FiStateNames.Form.Add
                : undefined,
            count$: this.fiSignalRHelperService.newFormIds$.pipe(map((v) => v.length)),
        });

        const hasAccessToFormReports = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.FormReports,
            AccessRightType.Write,
        );
        if (hasAccessToFormReports && !this.isMobilePhone()) {
            this.tabs.push({
                Title: this.appTextService.get('reports'),
                Sref: FiStateNames.Form.Report.List,
                count$: this.formService.newAnswerSets$.pipe(map((v) => v.length)),
            });
        }

        super.updateSelectedTabFromState();

        this.pageTitleService.setTitleForList(ObjectTypes.Form);
    }

    isMobilePhone() {
        return this.detectDeviceService.isMobilePhone();
    }
}
